import { Button } from '@workspace/ui/components/button'
import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { TextInput } from '@workspace/ui/components/text-input'
import { useState } from 'react'

interface CategoryFormProps {
  initialName?: string
  initialDescription?: string
  onSubmit: (data: { name: string; description: string }) => void
  onCancel: () => void
  isSubmitting: boolean
}

export function CategoryForm({
  initialName = '',
  initialDescription = '',
  onSubmit,
  onCancel,
  isSubmitting,
}: CategoryFormProps) {
  const [name, setName] = useState(initialName)
  const [description, setDescription] = useState(initialDescription)

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit({ name, description })
      }}
      className="flex flex-wrap items-center gap-2"
    >
      <TextInput
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Category name"
        required
        className="w-56"
      />
      <TextInput
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Description (optional)"
        className="w-72"
      />
      <CtaButton type="submit" size="sm" loading={isSubmitting} disabled={!name}>
        Save
      </CtaButton>
      <Button type="button" size="sm" variant="ghost" onClick={onCancel}>
        Cancel
      </Button>
    </form>
  )
}
